export { default as AddSquare2 } from './AddSquare2';
export { default as Add2 } from './Add2';
export { default as ArrowSquareDown } from './ArrowSquareDown';
export { default as ArrowSquareRight } from './ArrowSquareRight';
export { default as Car2 } from './Car2';
export { default as Circle } from './Circle';
export { default as Clock2 } from './Clock2';
export { default as Danger2 } from './Danger2';
export { default as Grid2 } from './Grid2';
export { default as Notification2 } from './Notification2';
export { default as RecordCircle2 } from './RecordCircle2';
export { default as Setting2 } from './Setting2';
export { default as StarFilled } from './StarFilled';
export { default as Task } from './Task';
export { default as UsersSolid } from './UsersSolid';
